import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param sellerId
 * @param sellingPriceId
 * @param orgId
 * @param tenantId
 * @param skuId
 * @param quantity
 * @param limit
 * @param page
 */
class OfferService {
  /**
   *
   * @param payload
   * @param userId
   * @return {Promise<*>}
   */
  createOffer = async (payload) => {
    const createdOffer = await Helpers.post({
      url: Constants.OFFERS,
      data: payload,
    });
    return createdOffer;
  };

  /**
   * @param skuId
   * @param sellerId
   * @param tenantProductId
   * @param tenantSellerId
   * @param userId
   * @return {Promise<*>}
   */
  getOffers = async (tenantProductId, tenantSellerId, tenantProductIds) => {
    const offers = await Helpers.get({
      url: `${Constants.GET_OFFER}?page=1&limit=80&${tenantProductId ? `&tenant_product_id=${tenantProductId}` : ''}&${tenantSellerId ? `&tenant_seller_id=${tenantSellerId}` : ''}&${tenantProductIds ? `&tenant_product_ids=${tenantProductIds}` : ''}`,
    });
    return offers;
  };

  /**
   * @param skuId
   * @param sellerId
   * @param page
   * @param userId
   * @return {Promise<*>}
   */
  getOffersBySku = async (sellerId, page) => {
    const offers = await Helpers.get({
      url: `${Constants.GET_OFFER_BY_SKU}?limit=10&map_seller_info=true&group_by_seller=true${sellerId ? `&seller_id=${sellerId}` : ''}${page ? `&page=${page}` : '&page=1'}`,
    });
    return offers;
  };

  /**
   * @param payload
   * @param userId
   * @return {Promise<*>}
   */
  updateOffer = async (payload) => {
    const updatedOffer = await Helpers.patch({
      url: Constants.UPDATE_OFFER,
      data: payload,
    });
    return updatedOffer;
  };

  /**
   * @param offerId
   * @param id
   * @return {Promise<*>}
   */
  deleteOffer = async (offerId) => {
    const deletedOffer = await Helpers.delete({
      url: `${Constants.DELETE_OFFER}?sku_offer_id=${offerId}`,
    });
    return deletedOffer;
  };

  /**
   *
   * @param {*} sellingPriceId
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} skuId
   * @param {*} quantity
   * @param {*} page
   * @param {*} limit
   * @return
   */
  getSellingPrices = async (sellingPriceId, orgId, tenantId, skuId, quantity, page, limit) => {
    let params = '';
    if (limit) params += `&limit=${limit}`;
    if (sellingPriceId) params += `&selling_price_id=${sellingPriceId}`;
    if (orgId) params += `&org_id=${orgId}`;
    if (tenantId) params += `&tenant_id=${tenantId}`;
    if (skuId) params += `&sku_id=${skuId}`;
    if (quantity) params += `&quantity=${quantity}`;
    const sellingPrice = await Helpers.get({
      url: `${Constants.SELLING_PRICE}${page ? `?page=${page}` : '?page=1'}${params}`,
    });
    return sellingPrice;
  };

  /**
   *
   * @param payload
   * @param userId
   * @return {Promise<*>}
   */
  createSellingPrice = async (payload) => {
    const createSellingPrice = await Helpers.post({
      url: Constants.SELLING_PRICE,
      data: payload,
    });
    return createSellingPrice;
  };

  /**
   *
   * @param payload
   * @param userId
   * @return {Promise<*>}
   */
  updateSellingPrice = async (payload) => {
    const updateSellingPrice = await Helpers.put({
      url: Constants.SELLING_PRICE,
      data: payload,
    });
    return updateSellingPrice;
  };

  /**
   *
   * @param productSkuId
   * @param tenantIds
   * @param page
   * @param limit
   * @param sellerId
   * @returns {Promise<*>}
   */
  getAllSellerOffers = async (productSkuId, tenantIds, page, limit, sellerId) => {
    let url = `${Constants.SELLER_OFFERS}?`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (tenantIds) url += `tenant_ids=${tenantIds}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (sellerId) url += `seller_id=${sellerId}`;
    const allSellerOffers = await Helpers.get({
      url,
    });
    return allSellerOffers;
  }

  // Archive Offer Price
  archiveOfferPrice = async (payload) => {
    const archiveOfferPrice = await Helpers.post({
      url: Constants.ARCHIVE_OFFER_PRICE,
      data: payload,
    });
    return archiveOfferPrice;
  };
}
export default new OfferService();
